//--------------------------------------------------------------
// Event Filtering
//--------------------------------------------------------------
import { COLLAPSE_ALL, SET_FILTER, SET_FILTER_DEFAULT, SET_FILTER_PARTIAL, SET_FILTER_CLEAN } from '../constants/action-types';
import { EventsFilter, Fleet } from '../interfaces';
import { AnalyticsService } from '../services';

export function updateFilterPartial(filterPartial: Partial<EventsFilter>) {
  AnalyticsService.event('filter', 'update', 'filter');
  return {
    type: SET_FILTER_PARTIAL,
    filterPartial,
  };
}

export function setFilter(filter: EventsFilter) {
  AnalyticsService.event('filter', 'update', 'filter');
  return {
    type: SET_FILTER,
    filter,
  };
}

export function setFilterClean() {
  AnalyticsService.event('filter', 'update', 'filter');
  return {
    type: SET_FILTER_CLEAN,
  };
}

export function setDefaultFilter(fleetId: Fleet['id']) {
  AnalyticsService.event('filter', 'update', 'filter');
  return {
    type: SET_FILTER_DEFAULT,
    fleetId,
  };
}

export function collapseAllFilters() {
  return {
    type: COLLAPSE_ALL,
  };
}
